<template>
  <div class="report">
    <div class="left-nav">
      <el-tabs v-model="activeName" tab-position="left" @tab-click="handleClick">
        <el-tab-pane :name="val.id" v-for="val in navList" :key="val.id">
          <span slot="label">
            <div class="title" style="font-size:16px">{{val.name}}</div>
            <div class="sub-title" v-for="v in val.list" :key="v.id">· {{v.name}}</div>
          </span>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="right-content">
      <div class="describe">
        <div class="macro-report" v-if="activeName == 'macro1'||activeName == 'macro2'">
          <p>
            <strong>研究报告是宏观高频模拟和预测、行业高频模拟和预测、宏观和行业全口径数据库三个产品数据分析结果的文字表达形式。无暇上数据库的朋友可通过研究报告便捷获取相关信息。</strong>
          </p>
          <p>
            <strong>研究报告分为快报、周报、月报、年报。</strong>
          </p>
          <p>
            <strong>年报</strong>在预测基础上给出全年的判断分析框架。
          </p>
          <p>
            <strong>月报</strong>跟踪这些预测和判断，结合预测滚动更新和全口径数据的变动，对原有判断做出评估和必要调整，并向需求和供给两侧分析经济增长动能的变化。
          </p>
          <p>
            <strong>周报</strong>关注最近一周高频模拟中的重要变动，评估对预测结果的影响。
          </p>
          <p>
            <strong>快报</strong>则是随机抓热点，有一说一，注重时效。
          </p>
          <p style="text-align:center">
            <img src="../../assets/img/17.png" alt />
          </p>
        </div>
        <div class="sw-report" v-if="activeName == 'SW'">
          <p>
            <strong>研究报告是数据库分析结果的文字表达形式。</strong>无暇上数据库的朋友可通过研究报告便
            捷获取相关信息。
            <strong>研究报告分为月报和周报</strong>。
          </p>
          <p>
            <strong>月报</strong>利用深度学习技术挖掘行业内、行业间指标的线性和非线性关系，对行业月度运行状况和后续趋势预测进行综合分析。通过月报，对行业格局现状和下一步结构性变动将有更具广度和深度的认识。
          </p>
          <p>
            <strong>周报</strong>基于先进高频模拟技术实时感知和描述周内行业波动情况，结合宏观与行业政策背景和新闻事件，勾勒行业演进动态画面，使用户同步而真切感受到行业发展脉动，从而更好地应对挑战、抓住机会。
          </p>
        </div>
        <div class="steel-report" v-if="activeName == 'Financial'">
          <p>
            <strong>研究报告是数据库分析结果的文字表达形式。</strong>无暇上数据库的朋友可通过研究报告便捷获取相关信息。
            <strong>研究报告分为月报、周报和快报。</strong>
          </p>
          <p>
            <strong>“月报”</strong>对钢铁行业实际需求和供给进行中长期预测分析。在需求侧，对钢铁下游行业房地产新开工面积、基建投资、机械行业工业增加值等30余项重点行业指标，进行10-12个月的趋势预判；同时利用AI方法构建腾景钢材实际需求指数，综合多维度需求给出更为清晰的宏观钢材实际需求预测。在供给侧，利用深度学习技术挖掘季节性规律和影响因素的相互作用规律，对粗钢、生铁等重要产品产量未来3个月的数值和走势进行预测推演和分析。
          </p>
          <p>
            <strong>“周报”</strong>聚焦黑色产业链，预测未来10-12周相关现货、期货和资本市场价格指数走势。以多品种钢材全国现货价格、煤炭和铁矿石价格为主，对单边价格和品种价格差进行预测分析；同时对国际有色、能源、黑色期货价格和资本市场指数价格走势作出研判，为钢铁行业日常生产采购、套期保值、战略决策等提供支持。
          </p>
          <p>
            <strong>“快报”</strong>着重展示预测结果中提炼出来的重要信息。所谓“快”，是指更简单、更直接地识别并提示预测结果给出的信号性信息。快报量化了各个指标在预测区间波动频率和数值异常较历史平均水平的差异程度，波动频率明显快于历史均值，将会启动波动预警；数值范围明显异于历史均值，则会启动数值预警。
          </p>
          <p style="text-align:center">
            <img src="../../assets/img/18.png" alt />
          </p>
        </div>
        <div class="bulk-report" v-if="activeName == 'Bulk'">
          <p>
            <strong>研究报告是数据库分析结果的文字表达形式。</strong>无暇上数据库的朋友可通过研究报告便捷获取相关信息。
            <strong>研究报告分为日报、周报和快报。</strong>
          </p>
          <p>
            <strong>“日报”</strong>是对全部跟踪重要品种未来9个交易日或自然日的走势进行预测推演和分析，同时包含各板块大宗商品期货、现货、基差、价差、库存数据和季节性分析。
          </p>
          <p>
            <strong>“周报”</strong>按照板块划分，回顾和跟踪上周板块内商品期货、现货、基差、价差和库存走势，同时对部分品种实现了未来9周左右的预测。
          </p>
          <p>
            <strong>“快报”</strong>着重展示随时突发的事件对大宗商品领域的影响，包括资产配置、通胀变化等。
          </p>
          <p style="text-align:center">
            <img src="../../assets/img/19.png" alt />
          </p>
        </div>
        <el-tabs v-model="activeTab" @tab-click="handleClick">
          <el-tab-pane :label="tab.name" v-for="tab in reportTabs" :key="tab.id" :name="tab.name"></el-tab-pane>
        </el-tabs>
        <div class="free" v-if="Free.length">
          <div class="title">精彩试读</div>
          <div class="report-list">
            <div
              class="item"
              v-for="report in Free"
              :key="report.id"
              @click="getReportDetail(report)"
            >
              <div class="left">
                <img :src="report.picUrl" alt />
              </div>
              <div class="right">
                <div class="report-title">{{report.fileTitle}}</div>
                <div class="report-time">{{report.publishTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="new-report" v-if="NotFree.length">
          <div class="title">最新研报</div>
          <div class="report-list">
            <div class="item" v-for="report in NotFree" :key="report.id" @click="goLogin">
              <div class="left">
                <img :src="report.picUrl" alt />
              </div>
              <div class="right">
                <div class="report-title">{{report.fileTitle}}</div>
                <div class="report-time">{{report.publishTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="more" v-if="!finished" @click="handleMore">
          查看更多
          <i class="el-icon-arrow-right"></i>
        </div>
        <div class="more" v-if="finished">没有更多了</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  findSystemReports,
  selectFileByid,
  findNewReportsSimplify
} from "@/api/report";
import mixin from "@/utils/mixins.js";
export default {
  mixins: [mixin],
  data() {
    return {
      activeName: "",
      activeTab: "",
      reportTabs: [],
      page: 1,
      Free: [],
      NotFree: [],
      finished: true,
      pdfsrc: "",
      navList: []
    };
  },
  watch: {
    $route() {
      // if (this.$route.query.system && !this.$route.query.id) {
      //   this.activeName = this.$route.query.system;
      // }
      this.Free = [];
      this.NotFree = [];
      this.page = 1;
      this.handleFindNewReportsSimplify();
    }
  },
  created() {
    this.Free = [];
    this.NotFree = [];
    this.page = 1;
    // 获取左侧菜单
    this.handleFindNewReportsSimplify();
  },
  methods: {
    handleClick() {
      this.Free = [];
      this.NotFree = [];
      this.page = 1;
      this.reportTabs = this.navList.filter(
        i => i.id == this.activeName
      )[0].list;
      this.activeTab = this.reportTabs[0].name;
      this.handleFindSystemReports();
    },
    async handleFindNewReportsSimplify() {
      let { data } = await findNewReportsSimplify();
      if (data.resultCode == 200) {
        this.navList = data.resultBody.reverse();
        if (this.$route.query.system) {
          if (!this.$route.query.id) {
            this.activeName = this.$route.query.system;
            let arr1 = this.navList.filter(
              i => i.id == this.$route.query.system
            );
            this.reportTabs = arr1[0].list;
          } else {
            let arr = this.navList.filter(i => i.name == this.$route.query.id);
            this.activeName = arr[0].id;
            this.reportTabs = arr[0].list;
          }
        } else {
          // 默认研报base
          this.reportTabs = this.navList[0].list;
          // 默认左侧菜单激活
          this.activeName = this.navList[0].id;
        }
        //  默认研报激活tab
        this.activeTab = this.reportTabs[0].name;
        this.handleFindSystemReports();
      } else {
        this.navList = [];
      }
    },
    async handleFindSystemReports() {
      let { data } = await findSystemReports({
        system: this.activeName,
        tabName: this.activeTab,
        page: this.page,
        size: 4
      });
      this.Free = data.resultBody.Free;
      this.NotFree = this.NotFree.concat(data.resultBody.NotFree);
      if (data.resultBody.NotFree.length < 4) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    },
    handleMore() {
      this.page++;
      this.handleFindSystemReports();
    },
    async getReportDetail(val) {
      let sysId = "";
      if (this.activeName == "macro") {
        sysId = 1;
      } else if (this.activeName == "SW") {
        sysId = 2;
      } else if (this.activeName == "Bulk") {
        sysId = 4;
      } else if (this.activeName == "Financial") {
        sysId = 3;
      }
      let { data } = await selectFileByid({
        id: val.id,
        sysId
      });
      this.goReportDetail(data.resultBody);
    },
    // 去报告详情
    goReportDetail(src) {
      // 存在浏览器缓存  解决刷新丢失
      sessionStorage.setItem("src", src);
      let routerJump = this.$router.resolve({
        name: "Detail"
      });
      window.open(routerJump.href, "_blank");
    },
    goLogin() {
      this.goMacro();
    }
  }
};
</script>

<style lang="scss" scoped>
.report {
  height: 100%;
  display: flex;
  .left-nav {
    height: 100%;
    min-width: 280px;
    background: #fff;
    /deep/ .el-tabs__item.is-active {
      background: #ffe8de;
      border: none;
      .title {
        color: #dd6643;
        font-size: 16px !important;
      }
      .sub-title {
        color: #303030;
      }
    }
    /deep/ .el-tabs__item {
      .title {
        font-size: 16px !important;
      }
    }
    /deep/ .el-tabs__item:hover {
      .sub-title {
        color: #303030;
      }
    }
    .sub-title {
      padding-left: 24px;
      line-height: 28px;
      font-size: 12px;
    }
  }
  .right-content {
    flex: 1;
    .describe {
      margin: 20px 0 0 20px;
      padding: 20px;
      background: #fff;
      border-radius: 10px;
      font-size: 14px;
      p {
        text-indent: 32px;
      }
      img {
        height: 320px;
      }
      .free,
      .new-report {
        .title {
          font-size: 22px;
          color: #202020;
          margin: 30px 0;
        }
        .report-list {
          display: flex;
          flex-wrap: wrap;
          .item {
            width: 50%;
            display: flex;
            margin-bottom: 12px;
            .left {
              height: 106px;
              width: 136px;
              padding-right: 14px;
              img {
                height: 100%;
                width: 100%;
                border: 1px solid #bdbdbd;
              }
            }
            .right {
              flex: 1;
              padding: 10px;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              color: #202020;
              .report-title {
                font-size: 16px;
              }
              .report-time {
                font-size: 12px;
              }
            }
          }
        }
      }
      .more {
        text-align: center;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
  /deep/ .el-tabs {
    .el-tabs__header {
      margin: 0;
      border-bottom: none;
      width: 99%;
    }
    .el-tabs__item {
      color: #242424;
      border: none;
      font-size: 14px;
      text-align: left;
      height: auto;
      border-bottom: 1px solid #e5e5e5;
    }
    .el-tabs__item.is-active {
      color: #dd6643;
      border: none;
    }
    .el-tabs__item:hover {
      color: #dd6643;
    }
    .el-tabs--card > .el-tabs__header .el-tabs__nav {
      border: none;
    }
    .el-tabs__nav-wrap::after {
      display: none;
    }
    .el-tabs__active-bar {
      background-color: #dd6643;
      height: 4px;
    }
  }
}
</style>